import { Link as MuiLink, Typography, Stack, Box, Button } from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router";
import { trackEvent } from "../util/analytics.ts";
import { EventCategory } from "@labs/shared/types/EventCategory.ts";

export const Footer = () => {
  const location = useLocation();
  const isInitialLandingPage = location.pathname === "/";

  return (
    <Stack
      gap={2}
      sx={{ mt: 2 }}
      direction={"column"}
      alignItems={"flex-start"}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        gap={4}
        alignItems={"center"}
        justifyContent={"space-between"}
        width={"100%"}
      >
        <Stack
          direction={"row"}
          gap={2}
          alignItems={"center"}
          justifyContent={{ xs: "space-between", sm: "center" }}
        >
          <img
            src="/cascadeLogoBare.svg"
            alt="Cascade Energy logo"
            width={112}
          />
          <Typography variant={"caption"} color={"text.secondary"}>
            &copy; 2025 Cascade Energy
          </Typography>
        </Stack>
        <Stack
          direction={"row"}
          gap={2}
          justifyContent={{ xs: "space-between", sm: "center" }}
        >
          <Button component={RouterLink} to="/guided-tour">
            Request a Guided Tour
          </Button>
          <Button
            component={RouterLink}
            to="mailto:erp-feedback@cascadeenergy.com"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
              trackEvent(
                EventCategory.Feedback,
                "Clicked Link",
                window.location.href,
              )
            }
          >
            Send feedback
          </Button>
        </Stack>
      </Stack>

      {isInitialLandingPage && (
        <Box mt={3}>
          <Typography variant="caption" color={"text.secondary"}>
            By submitting data via this tool, you agree that Cascade Energy, LLC
            ("Cascade") may use your data in compliance with our{" "}
            <MuiLink
              href="https://cascadeenergy.com/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              privacy policy
            </MuiLink>
            . Additionally, we may anonymize data you submit and aggregate it
            with information provided by other users of this tool ("Statistical
            Data"). As between you and Cascade, Cascade owns all right, title,
            and interest, including all intellectual property rights, in and to
            such Statistical Data and this tool. Cascade provides this tool as a
            courtesy to all users. Cascade does not warrant that the information
            returned by this tool in response to the data you submit
            ("Responses") may be accurate, reliable, or applicable to your
            specific needs, and Cascade provides this tool as-is, without
            warranty of any kind. You use the tool at your own risk and you are
            responsible for verifying the accuracy, reliability, and
            applicability of all Responses.
          </Typography>
        </Box>
      )}
    </Stack>
  );
};
